import ReactComponent from '../app/ReactComponent'
import Query from '../app/Query'
import {Col, Layout, List, Row, Space, Spin, Table, Tag, Typography} from 'antd'
import {prettyDate, prettyNumber} from '../helpers/utils'
import {getStoreNameByStoreId} from '../services/stores'
import {LeftOutlined} from '@ant-design/icons'
import React from 'react'

export class CompensationsOverviewPage extends ReactComponent {
  state = {
    loading: false,
    stores: [],
    purchases: [],
    overview: {
      table: {
        loading: true,
        headers: [
          {
            title: 'Datum výplaty',
            dataIndex: 'payment_time',
            key: 'date',
          },
          {
            title: 'Pobočka',
            dataIndex: 'store',
            key: 'store',
          },
          {
            title: 'Typ výplaty',
            dataIndex: 'name',
            key: 'name',
          },
          {
            title: 'Vyplacená částka',
            dataIndex: 'price',
            key: 'price'
          }
        ],
        rows: []
      },
      pagination: {
        defaultCurrent: 1,
        total: 0,
        defaultPageSize: 10,
        current: 1
      }
    }
  }

  async componentDidMount() {

    this.scrollToTop()

    await this.getPageData()

    let res = await this.getPurchasesData()

  }

  async getPageData() {

    await this.updateState({
      stores:  await this.$app.$store('common').getStores()
    })

  }

  async getPurchasesData (offset = this.state.overview.pagination.current) {

    void this.updateState({ loading: true })

    try {

      const query = new Query('purchases')

      query.add('count', this.state.overview.pagination.defaultPageSize)
      query.add('offset', (offset - 1) * this.state.overview.pagination.defaultPageSize)
      query.add('sort_field', 'payment_time')
      query.add('sort_direction', 'desc')
      query.add('purchase_items_extension', true)

      const { purchases = [], total_items = 0 } = await this.$api({
        action: 'carecloud_user_api',
        route: query.route
      })


      let rows = []

      purchases.forEach((item) => {
        const payment_time = prettyDate(item.payment_time) || ""

        item.purchase_items.forEach((purchase_item) => {
          rows.push({
            payment_time,
            //store: this.getBookingStoreName(item.additional_properties).split(', ').slice(1).join(', '),
            name: purchase_item.product_name,
            price: <Tag className="points">{prettyNumber(purchase_item.price)} Kč</Tag>,
            store: getStoreNameByStoreId(this.state.stores, item.store_id)
            //status: <ReservationTag status={this.getBookingStatusName(item.booking_item_status)}/>,
            //action: <CancelReservationModal item={item} onSubmit={(...args) => {
            //  this.cancelBooking(...args)
            //}}/>
          })
        })

      })

      this.setState((prevState) => ({
        ...prevState,
        overview: {
          ...prevState.overview,
          table: {
            ...prevState.overview.table,
            rows: rows
          },
          pagination: {
            ...prevState.overview.pagination,
            total: total_items,
            current: offset
          }
        },
        loading_table: false
      }))

      return Promise.resolve()

    } catch (error) {

      console.error(error)

    } finally {

      void this.updateState({ loading_page: false })

    }
  }

  tablePaging = async (args) => {
    let current = typeof args === 'number' ? args : args.current

    await this.updateState({ loading_table: true })

    await this.getPurchasesData(current)

    this.scrollToTop()

    void this.updateState({ loading_table: false })

  }

  render() {
    return (
      <Layout tagName="main">
        <Row align="center">
          <Col xs={24} style={{ maxWidth: 1400 }}>
            <Row align="center mb-4">
              <Col xs={24} md={24} xl={20}>
                <Space className="title-with-btn" size={[0, 0]}>
                  <a onClick={() => {
                    this.backToHistory()
                  }}><LeftOutlined/><span className="back-to-btn">Zpět</span></a>
                  <h1 className="mb-0">Přehled mých náhrad</h1>
                </Space>
              </Col>
            </Row>
          </Col>
          <Col xs={0} xl={24} style={{ maxWidth: 1400 }}>
            <Spin spinning={this.state.loading_table} size={'large'}>
              <Table
                columns={this.state.overview.table.headers}
                dataSource={this.state.overview.table.rows}
                onChange={this.tablePaging}
                pagination={{
                  defaultCurrent: this.state.overview.pagination.defaultCurrent,
                  total: this.state.overview.pagination.total,
                  defaultPageSize: this.state.overview.pagination.defaultPageSize,
                  current: this.state.overview.pagination.current
                }}
              />
            </Spin>
          </Col>
          <Col xs={23} sm={24} xl={0} style={{ maxWidth: 500 }}>
            <Spin spinning={this.state.loading_table} size={'large'}>
              <List header="Datum výplaty / Vyplacená částka / Typ výplaty / Pobočka"
                    pagination={{ ...this.state.overview.pagination, onChange: this.tablePaging }}
                    dataSource={this.state.overview.table.rows} renderItem={(item) => (
                <List.Item>
                  <Space direction="vertical" style={{ width: '100%', textAlign: 'left' }}>
                    <Space direction="horizontal" className="list-tag-btn-wrapper" wrap>
                      <Typography.Text>{item.payment_time}</Typography.Text>
                      <Typography.Text>{item.price}</Typography.Text>
                    </Space>
                    <Space direction="horizontal">
                      <Typography.Text>{item.name}</Typography.Text>
                    </Space>
                    <Space direction="horizontal">
                      <Typography.Text>{item.store}</Typography.Text>
                    </Space>
                  </Space>
                </List.Item>
              )}/>
            </Spin>
          </Col>
        </Row>
      </Layout>
    )
  }
}